import React from 'react';
import { Link } from 'gatsby';

/**
 * 站内互链区块（GEO 导航页互链）
 * props:
 *   links: Array<{ label: string, to: string }>  必填
 *   title: string                                 可选，如「延伸阅读」
 */
const RelatedLinks = ({ links = [], title }) => {
  if (!links.length) return null;
  return (
    <section className="related-links" aria-label={title || '相关服务'}>
      {title && <h2 className="related-links__title">{title}</h2>}
      <nav aria-label={title || '相关服务'}>
        <ul className="related-links__list">
          {links.map(link => (
            <li key={link.to} className="related-links__item">
              <Link className="related-links__link" to={link.to}>
                {link.label}
              </Link>
            </li>
          ))}
        </ul>
      </nav>
    </section>
  );
};

export default RelatedLinks;
